// Lookup tables shared by difficulty.ts and difficulty-features.ts — kept as a
// separate leaf so neither module creates a circular dependency.

// Grade contribution per texture rank — block (rank 1) is the Preparatory baseline and
// adds nothing beyond a melody; the real jumps are broken/alberti (rank 2) and arpeggios
// (rank 3). Calibrated against the judge (songs/difficulty-eval.json); see difficulty.ts.
const TEXTURE_GRADE: Record<number, number> = { 0: 0, 1: 0, 2: 0.5, 3: 1.2 };
export const textureGrade = (rank: number): number => TEXTURE_GRADE[rank] ?? 1.2;

// Hardest accompaniment texture implied by a skill (the dominant axis).
export const TEXTURE_RANK: Record<string, number> = {
  "five-finger": 0,
  "scale-major": 1,
  "scale-minor": 1,
  "blocked-chords": 1,
  "triad-major": 1,
  "triad-minor": 1,
  "inversion-1": 1,
  "inversion-2": 1,
  dom7: 1,
  "prog-I-IV-V": 1,
  "prog-I-V-vi-IV": 1,
  "prog-ii-V-I": 1,
  "prog-12-bar-blues": 1,
  "broken-chords": 2,
  "alberti-bass": 2,
  arpeggios: 3,
};

// Accidental count for the keys the corpus uses (default 0).
export const KEY_ACCIDENTALS: Record<string, number> = {
  "C major": 0,
  "A minor": 0,
  "G major": 1,
  "F major": 1,
  "E minor": 1,
  "D minor": 1,
  "D major": 2,
  "B-flat major": 2,
  "Bb major": 2,
  "G minor": 2,
  // Keys outside the drilled C/F/G vocabulary still get a graceful estimate (uploads).
  // A major key's accidental count is |line-of-fifths position|.
  "A major": 3,
  "Eb major": 3,
  "E major": 4,
  "Ab major": 4,
  "B major": 5,
  "Db major": 5,
  "F# major": 6,
  "Gb major": 6,
  "C# major": 7,
  "Cb major": 7,
};
